<tux-page-header
  [breadcrumbs]="[{ path: '', title: 'Home' }, { title: 'Current Customers' }]"
  [subMenu]="false"
  pageTitle="Platform Customers"
>
  <tux-page-header-buttons>
    <p-button
      (click)="openNewCustomerForm()"
      label="Add new Customer"
    ></p-button>
  </tux-page-header-buttons>
</tux-page-header>

<ng-template #statusRenderer let-field="field" let-row="row">
  <tux-tag [text]="tagLabels[field]" [type]="tagColors[field]"></tux-tag>
</ng-template>

<ng-template #customNameRenderer let-field="field" let-row="row">
  <tux-link [path]="[row.customerId]">
    {{ field }}
  </tux-link>
</ng-template>

<div>
  <tux-mini-filter
    [formControlInput]="statusControl"
    [options]="statusOptions"
    header="Filter By Status"
  ></tux-mini-filter>
  <lib-table-wrapper
    [config]="{
      data: filteredData$,
      columnPicker: true,
      columns: [
        {
          field: 'customerId',
          header: 'Customer ID',
        },
        {
          field: 'name',
          header: 'Customer Name',
          customCellRenderer: customNameRenderer,
        },
        {
          field: 'contactEmail',
          header: 'Primary Contact',
        },
        {
          field: 'owner',
          header: 'Account Owner',
        },
        {
          field: 'domain',
          header: 'Domain',
        },
        {
          field: 'crmType',
          header: 'CRM Type',
        },
        {
          field: 'createdDate',
          header: 'Date Added',
          cellType: 'date',
        },
        {
          field: 'status',
          header: 'Status',
          customCellRenderer: statusRenderer,
        },
      ],
      download: true,
      downloadTableCSV: true,
      search: true,
      sort: true,
      globalFilterFields: ['name'],
      defaultColumns: [
        'CRM Type',
        'Customer Name',
        'Status',
        'Date Added',
        'Account Owner',
        'Primary Contact',
      ],
    }"
    [loading]="loading"
  ></lib-table-wrapper>
</div>
